/**
 * Vendor-neutral log severity for the shared application logger.
 *
 * This module is intentionally dependency-free so it can be imported by the
 * logger core, the logger channels, and `utils/environment` without creating a
 * require cycle. Datadog-specific status mapping lives in the Datadog channel;
 * severity does not imply a delivery destination.
 */
export enum LogLevel {
  trace = 10,
  debug = 20,
  info = 30,
  warn = 40,
  error = 50,
  fatal = 60,
}
